import { type PanelConfigTypename } from './panel-types';

export interface PanelDragData extends Record<string, unknown> {
  type: 'panel';
  panelId: string;
  rowIndex: number;
  panelIndex: number;
  isOnlyPanelInRow: boolean;
}

export interface NewPanelDragData extends Record<string, unknown> {
  type: 'new-panel';
  typename: PanelConfigTypename;
}

export type DragSourceData = PanelDragData | NewPanelDragData;

/** Carries a closest edge (left/right) attached via the hitbox package. */
export interface PanelTargetData extends Record<string, unknown> {
  type: 'panel';
  rowIndex: number;
  panelIndex: number;
}

export interface RowTargetData extends Record<string, unknown> {
  type: 'row';
  rowIndex: number;
}

/** `rowIndex` is the insertion index: 0 = above the first row, panels.length = below the last. */
export interface RowDropZoneTargetData extends Record<string, unknown> {
  type: 'row-drop-zone';
  rowIndex: number;
}

export type DropTargetData = PanelTargetData | RowTargetData | RowDropZoneTargetData;

export type HorizontalEdge = 'left' | 'right';

export const isPanelDragData = (data: Record<string, unknown>): data is PanelDragData =>
  data.type === 'panel' && typeof data.panelId === 'string';

export const isNewPanelDragData = (data: Record<string, unknown>): data is NewPanelDragData =>
  data.type === 'new-panel';

export const isDragSourceData = (data: Record<string, unknown>): data is DragSourceData =>
  isPanelDragData(data) || isNewPanelDragData(data);

export const isDropTargetData = (data: Record<string, unknown>): data is DropTargetData =>
  data.type === 'panel' || data.type === 'row' || data.type === 'row-drop-zone';
